import * as types from '../constants/ActionTypes';
import * as consts from '../../home/constants/ActionTypes';

export function switchContentToggle(exp) {
  return {
    type: types.SWITCH_CONTENT_TOGGLE,
    payload: exp,
  };
}

export function toggleRelated(exp) {
  return {
    type: consts.TOGGLE_RELATED,
    payload: exp,
  };
}

export function resetToggleRelated() {
  return {
    type: consts.RELATED_TOGGLE_RESET,
    payload: undefined,
  };
}
